import BannerProjects from "../../components/bannerProjects";
import ComoFazemos from "../../components/comoFazemos";
import Rodape from "../../components/rodape";
import BusinessOtimize from "../../components/businessOtimize";
import BusinessBeneficios from "../../components/businessBeneficios";

function ATO() {
    return (
        <>
            <BannerProjects
                backgroundImage="../assets/cover-ato.png"
                bgMobile="../assets/cover-ato-mobile.png"
                title=""
                titleBold="/ATO"
                iconSrc="../assets/icone-projectiva-behub.png"
                iconAlt="Projectiva BeHub"
                iconText="be."
                iconTextBold="hub"
                descriptionBold=""
                description="Somos líderes na adoção de metodologias ágeis, promovendo a implementação eficiente de frameworks, a capacitação da equipe e uma cultura de melhoria contínua, garantindo agilidade em todos os níveis da organização."
                footerText="VERTICAL PROJECTS | Business Agility"
                buttonText="Quero me conectar"
                buttonColor="from-[#4B3BDB] to-[#A002CB]"
                brand="behub"
            />
            <ComoFazemos
                title="Como fazemos?"
                cards={[
                    {
                        icon: "/assets/servicos/facilitacao_icon.svg",
                        iconHover: "/assets/servicos/facilitacao_icon.svg",
                        title: "Implementação de Frameworks Ágeis:",
                        text: "Adaptação, otimização e integração de Scrum, Kanban e Lean.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                    {
                        icon: "/assets/servicos/engajamento_icon.svg",
                        iconHover: "/assets/servicos/engajamento_icon.svg",
                        title: "Capacitação e treinamento da equipe:",
                        text: "Treinamentos para desenvolvimento de habilidades e cultura ágil.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                    {
                        icon: "/assets/servicos/adocao_icon.svg",
                        iconHover: "/assets/servicos/adocao_icon.svg",
                        title: "Monitoramento e melhoria contínua:",
                        text: "Monitoramento, ajustes preditivos e evolução ágil constante.",
                        glowColor: "#A002CB",
                        height: "350"
                    },
                ]}
            />
            <BusinessOtimize
                backgroundImage="../assets/background_ato.png"
                bgMobile="../assets/background_ato_mobile.png"
                title={
                    <>
                        Aceleramos a sua jornada de transformação ágil, <br />
                        <span className="font-inter-bold">
                            impulsionando a evolução contínua.
                        </span>
                    </>
                }
                buttonText="Otimize seu negócio"
                buttonLink="#"
            />
            <BusinessBeneficios
                title="Benefícios"
                text={
                    <>
                        Entregas{" "}
                        <span className="font-inter-bold">efetivas</span>,
                        resultados{" "}
                        <span className="font-inter-bold">reais.</span> O{" "}
                        <span className="font-inter-bold">ATO</span> é um
                        conjunto de benefícios que torna tangíveis as entregas
                        para as empresas.
                    </>
                }
                buttonText="Otimize seu negócio!"
                buttonLink="#"
                buttonActionText="Contratar"
                items={[
                    {
                        icon: "/assets/servicos/agilidade_icon_purple.svg",
                        title: "AGILIDADE ORGANIZACIONAL",
                        description:
                            "Maior flexibilidade para adaptação às mudanças do mercado.",
                    },
                    {
                        icon: "/assets/servicos/eficiencia_icon_purple.svg",
                        title: "EFICIÊNCIA ORGANIZACIONAL",
                        description:
                            "Redução de custos e tempo de entrega, através de processos otimizados.",
                    },
                    {
                        icon: "/assets/servicos/melhoria_icon_purple.svg",
                        title: "INOVAÇÃO CONTÍNUA",
                        description:
                            "Ambiente que incentiva a inovação, com ciclos rápidos de experimentação.",
                    },
                    {
                        icon: "/assets/servicos/alinhamento_icon_purple.svg",
                        title: "ALINHAMENTO ESTRATÉGICO",
                        description:
                            "Projetos e recursos alinhados com as metas de negócio.",
                    },
                ]}
            />
            <Rodape />
        </>
    );
}

export default ATO;
